<template>
  <div v-if="toastId > 0"  class="toast-container">
    <div
      :class="['toast', 'toast--info']">
      <div class="toast__content">
        <div class="toast__message">
          <div class="toast__text"><el-link style="color: #00a4ff;font-size: 15px;" @click="toArchives()">{{ toast.message }}</el-link></div>
        </div>
        <button class="toast__close" @click="removeToast(toast.id)">×</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Toast',
  data() {
    return {
      toasts: [],
      toast: {},
      toastId: 0
    }
  },
  methods: {
    show(options) {
      this.toastId = 1
      this.toast = {
        type: options.type || 'info',
        message: options.message || '',
        duration: options.duration || 3000,
        progress: 100
      }
    },

    info(message, duration = 3000) {
      return this.show({
        type: 'info',
        title: '信息',
        message,
        duration
      })
    },

    toArchives() {
      window.open('/research-pc/archives/manage/index')
    },
    removeToast() {
      this.toastId = 0
    },

    clear() {
      this.toasts = []
      this.toast = {}
    }
  }
}
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 70px;
  right: 10px;
  z-index: 100000;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.toast {
  background: white;
  border-radius: 8px;
  padding: 40px 0 40px 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: toastSlideIn 0.3s ease;
  position: relative;
  overflow: hidden;
  height: 100px;
  width: 300px;
}

.toast__content {
  gap: 12px;
}

.toast__message {
  flex: 1;
  min-width: 0;
}

.toast__text {
  font-size: 13px;
  color: #6b7280;
  line-height: 1.4;
}

.toast__close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 25px;
  cursor: pointer;
  color: #9ca3af;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
  flex-shrink: 0;
}

.toast__close:hover {
  background: #f3f4f6;
  color: #374151;
}

.toast--error .toast__progress-bar {
  background-color: #ef4444;
}

.toast--info .toast__progress-bar {
  background-color: #3b82f6;
}

@keyframes toastSlideIn {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (max-width: 640px) {
  .toast-container {
    right: 10px;
    left: 10px;
    max-width: none;
  }

  .toast {
    padding: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/toast-tip/index.vue